import styled from "styled-components";

type Props = {
    $offset?: number
}

export default styled.div<Props>`
    width: 0.6em;
    height: 0.6em;
    border-radius: 0.5em;
    background-color: #e5a50e;
    position: absolute;
    top: 1em;
    left: ${({ $offset = 0}) => $offset * 1.5 + 1.5}em;
    z-index: 6;
    box-shadow: inset -1px -2px 3px #00000050;
`